import { getTitle, isCubePlatform } from '@/utils/comUtils'
export const HELP_DATA = {
  faceInput: {
    index: 'faceInput',
    title: '人脸录入',
    data: {
      admin: [
        '<p>点击页面上方人脸录脸管理，进入人脸录脸页面。</p>',
        '<div><img src="/campusleave/static/img/help/help1-1.png"/></div>',
        '<p><b>管理员</b>：管理全校的人脸信息，可以进行人脸录脸、删除。</p>',
        '<p><b>班主任</b>：管理对应班级的人脸信息，可以进行人脸录脸、删除。</p>',
        '<p><b>家长</b>：为孩子或者其他家庭成员录脸，当孩子属于低年级学生或者幼儿时，刷脸会存在一定的误识别概率，强烈建议以家长刷脸代替儿童刷脸。</p>',
        '<p class="help-title"><span>常见问题：</span></p>',
        '<p><b>1、提示人脸重复</b></p>',
        '<p>通常情况为该成员人脸已录入至其他人员名下，需要根据提示进行调整。</p>',
        '<p><b>2、 录入人脸后产生误识别或者识别慢</b></p>',
        '<p>请查看对应成员的人脸照片，是否存在照片模糊、五官及眉毛遮挡、表情夸张、角度偏移、光线过亮或过暗等质量偏低的情况，如存在以上情况，需要管理员或班主任进行人脸照片的更新。</p>',
        '<div><img src="/campusleave/static/img/help/help1-2.png"/></div>'
      ],
      headmaster: [
        '<p>点击页面上方人脸录脸管理，进入人脸录脸页面。</p>',
        '<div><img src="/campusleave/static/img/help/help12-1.png"/></div>',
        '<p><b>班主任</b>：可以管理对应班级的人脸信息，可以进行人脸录脸和删除。</p>',
        '<p><b>家长</b>：为孩子或者其他家庭成员录脸，当孩子属于低年级学生或者幼儿时，刷脸会存在一定的误识别概率，强烈建议以家长刷脸代替儿童刷脸。</p>',
        '<p class="help-title"><span>常见问题：</span></p>',
        '<p><b>1、提示人脸重复</b></p>',
        '<p>通常情况为该成员人脸已录入至其他人员名下，需要根据提示进行调整。</p>',
        '<p><b>2、 录入人脸后产生误识别或者识别慢</b></p>',
        '<p>请查看对应成员的人脸照片，是否存在照片模糊、五官及眉毛遮挡、表情夸张、角度偏移、光线过亮或过暗等质量偏低的情况，如存在以上情况，需要管理员或班主任进行人脸照片的更新。</p>',
        '<div><img src="/campusleave/static/img/help/help12-2.png"/></div>'
      ],
      guardian: [
        '<p>点击页面上方人脸录脸管理，进入人脸录脸页面。</p>',
        '<div><img src="/campusleave/static/img/help/help15-1.png"/></div>',
        '<p>家长可以为孩子或者其他家庭成员录脸；</p>',
        '<p>请注意，为保证孩子的安全，已录入人脸修改请联系管理员或班主任，家长无法自行录脸。</p>',
        '<p>当孩子属于低年级学生或者幼儿时，刷脸会存在一定的误识别概率，强烈建议以家长刷脸代替儿童刷脸。</p>',
        '<p>录入照片时，应该保持正脸、光线明亮均匀，录脸时应避免五官及眉毛遮挡、表情夸张、角度偏移、光线过亮或过暗等情况。</p>',
        '<div><img src="/campusleave/static/img/help/help15-2.png"/></div>'
      ]
    },
    authorize: []
  },
  attendanceDetail: {
    index: 'attendanceDetail',
    title: '日打卡详情',
    data: {
      admin: [
        '<p>进入学生考勤后，首页显示今日的日打卡统计。</p>',
        '<div><img src="/campusleave/static/img/help/help6-1.png"/></div>',
        '<p>当日统计数据分为汇总数据和班级出勤数据两类。点击汇总区域查看日打卡详情，点击右上角查看月统计。</p>',
        '<div><img src="/campusleave/static/img/help/help6-2.png"/></div>',
        '<p>考勤汇总数据来自于所以添加至考勤组的人员。计算方法为：实到人数/应到人数。各班级考勤数据汇总同理，所有参与考勤的班级会显示考勤汇总。</p>'
      ],
      headmaster: [
        '<p>进入学生考勤后，首页显示今日的日打卡统计。</p>',
        '<div><img src="/campusleave/static/img/help/help13-1.png"/></div>',
        '<p>当日统计数据分为汇总数据和班级出勤数据两类。点击汇总区域查看日打卡详情，点击右上角查看月统计。</p>',
        '<div><img src="/campusleave/static/img/help/help13-2.png"/></div>',
        '<p>考勤汇总数据来自于所以添加至考勤组的人员。计算方法为：实到人数/应到人数。各班级考勤数据汇总同理，所有参与考勤的班级会显示考勤汇总。</p>',
        '<p>点击汇总数据可以进入查看考勤异常的具体名单，以及对应人员的考勤详情。</p>'
      ],
      guardian: []
    },
    authorize: []
  },
  attendanceMonth: {
    index: 'attendanceMonth',
    title: '月统计',
    data: {
      admin: [
        '<p>月统计可以搜索指定人员进行考勤情况查看，或者筛选对应人员查看考勤详情</p>',
        '<div><img src="/campusleave/static/img/help/help7-1.png"/></div>'
      ],
      headmaster: [
        '<p>月统计可以搜索指定人员进行考勤情况查看，或者筛选对应人员查看考勤详情</p>',
        '<div><img src="/campusleave/static/img/help/help14-1.png"/></div>'
      ],
      guardian: []
    },
    authorize: []
  },
  schoolSegment: {
    index: 'schoolSegment',
    title: '上下学时间段',
    data: {
      admin: [
        '<p class="help-title"><span>上下学时段</span></p>',
        '<p>上下学时段用于标识考勤日期的具体时间段，系统将根据上下学时段来进行刷脸打卡类型的自动判断。</p>',
        '<div><img src="/campusleave/static/img/help/help8-1.png"/></div>',
        '<p>上下学时段可以进行保存，管理员可以根据机构需要灵活设置多个时间进行选择。单日最多可以设置4个上下学时间段。时间段之间不可重复。</p>',
        '<div><img src="/campusleave/static/img/help/help8-2.png"/></div>',
        '<p><b>周五提前放学</b>：可以单独创建周五考勤时间，实现周五提前放学的考勤需求。</p>',
        '<p><b>周日提前到校</b>：住校生及其他要求提前到校的情况，可以在周日设置单独的考勤时间。</p>',
        '<p><b> 走读中午、傍晚放学</b>：走读生中午、傍晚需暂时离校的，可以设置多个考勤时段，实现考勤需求。</p>',
        '<p class="help-title"><span>考勤时间图示</span></p>',
        '<div><img src="/campusleave/static/img/help/help8-3.png"/></div>',
        '<p><b>上学时间</b>是最晚到校时间，晚于该时间进行的第一次打卡将记为迟到。</p>',
        '<p><b>下学时间</b>为最早离校时间，早于该时间的非首次打卡记为早退。</p>'
      ],
      headmaster: [],
      guardian: []
    },
    authorize: []
  },
  timeSet: {
    index: 'timeSet',
    title: '打卡时间段设置',
    data: {
      admin: [
        '<div><img src="/campusleave/static/img/help/help9-1.png"/></div>',
        '<p>我们提供了上下学最早最晚打卡时间的设置，以防止成员的打卡记录被计入错误时段。</p>',
        '<p>最早上学前，无法打上学卡，上学时间后至最晚上学时间前非首次打卡，只记录时间。</p>',
        '<p>最晚上学时间后，无法打上学卡，按早退打卡记录。</p>',
        '<p>最晚下学后，无法打下学卡。最晚下学前未打卡，在下学时间，记“未打卡”，在最晚下学时间发送“未打卡”通知。</p>',
        '<p class="help-title"><span>图示及案例</span></p>',
        '<div><img src="/campusleave/static/img/help/help9-2.png"/></div>',
        '<p>设置上下学时间为8:00~18:00。上学最早打卡时段为6:00，上学最晚打卡时段为10:00，下学最晚打卡时段为19:00。</p>',
        '<p>成员在5点打卡，不会计入上学。6-8点正常上学打卡，8-10点打卡为迟到打卡，10点后至18:00为早退打卡，18:00-19:00为正常下学打卡，19:00后打卡不计入下学打卡。</p>'
      ],
      headmaster: [],
      guardian: []
    },
    authorize: []
  },
  notice: {
    index: 'notice',
    title: '通知配置',
    data: {
      admin: [
        '<p>配置班主任接收的通知：</p>',
        '<p>班主任收到本班级学生刷脸打卡的通知，包括：上学、下学、上学未打卡、迟到、早退、下学未打卡、缺勤、日统计、月统计等通知；</p>',
        '<p>发送时间如下图：</p>',
        '<div><img src="/campusleave/static/img/help/help10-1.png"/></div>',
        '<p>每个通知只会发送一次。</p>',
        '<p>配置家长接收的通知：</p>',
        '<p>家长收到学生刷脸打卡的通知，包括上学、下学；学生到校发送上学通知，学生离校发送下学通知；</p>',
        '<div><img src="/campusleave/static/img/help/help10-2.png"/></div>'
      ],
      headmaster: [],
      guardian: []
    },
    authorize: []
  },
  deviceForbid: {
    index: 'deviceForbid',
    title: '设备禁用考勤时段',
    data: {
      admin: [
        '<p>设备禁用考勤时段设置后，在时段范围内，无法通过在智能门禁上刷脸考勤，但可以正常通行。</p>',
        '<div><img src="/campusleave/static/img/help/help4-1.png"/></div>',
        '<p>设置后的时间段关闭学生考勤，可以设置多个时间段，每个时间段之间不能重叠。</p>',
        '<div><img src="/campusleave/static/img/help/help4-2.png"/></div>'
      ],
      headmaster: [],
      guardian: []
    },
    authorize: []
  },
  monthAndMonth: {
    index: 'monthAndMonth',
    title: '打卡月历与月统计',
    data: {
      admin: [],
      headmaster: [],
      guardian: [
        '<p>进入学生考勤后，首页显示本月打卡月历。</p>',
        '<div><img src="/campusleave/static/img/help/help16-1.png"/></div>',
        '<p>家长可以选择不同日期查看当日考勤详情，查看相应打卡信息。有多个孩子时，可以点击左上角切换不同孩子的打卡月历。</p>',
        '<p>点击右上角查看个人月统计：</p>',
        '<div><img src="/campusleave/static/img/help/help16-2.png"/></div>',
        '<p>个人月统计可以对本月考勤异常进行汇总展示，家长可以点击对应考勤异常种类查看详情。</p>'
      ]
    },
    authorize: []
  },
  leaveProcess() {
    return {
      index: 'leaveProcess',
      title: '请假审批流程',
      isNotInAttendance: true,
      data: {
        admin: [
          '<p>通过设置审批流程，班主任或家长代学生请假后，可以根据审批流程指定对应的人员进行审批及抄送审批结果；</p>',
          '<p class="help-title"><span>设置审批流程</span></p>',
          '<p>1、打开浏览器，输入oa.dingtalk.com扫描或使用钉钉账号登陆</p>',
          '<div><img src="/campusleave/static/img/help/help5-1.png"/></div>',
          '<p>2、选择“工作台”</p>',
          '<div><img src="/campusleave/static/img/help/help5-2.png"/></div>',
          '<p>3、找到“审批”</p>',
          '<div><img src="/campusleave/static/img/help/help5-3.png"/></div>',
          `<p>4、在审批管理中，找到<${
            isCubePlatform() ? '魔方' : '魔点'
          }学生请假>，点击“编辑”；（注：该审批有注明，由${getTitle()}提供）</p>`,
          '<div><img src="/campusleave/static/img/help/help5-4.png"/></div>',
          '<p>5、选择“流程设计”，设置流程并发布</p>',
          '<div><img src="/campusleave/static/img/help/help5-5.png"/></div>',
          '<p class="help-title"><span>常见问题</span></p>',
          '<p><b>1、怎么让班主任审批？</b></p>',
          '<p>选择表单联系人，选择编辑人</p>',
          '<div><img src="/campusleave/static/img/help/help5-6.png"/></div>',
          '<p><b>2、怎么改请假条件？</b></p>',
          '<p>不支持修改</p>',
          '<p><b>3、保安、保健老师怎么知道？</b></p>',
          '<p>审批条件添加抄送人</p>',
          '<div><img src="/campusleave/static/img/help/help5-7.png"/></div>',
          '<p><b>4、不设置审批会怎么样？</b></p>',
          '<p>班主任或家长替学生发起请假后，默认直接同意请假；</p>',
          '<p><b>5、哪些人可以给学生请假？</b></p>',
          '<p>管理员、该学生班主任或家长可以代学生请假，其他人员无权限给学生请假；</p>',
          '<p><b>6、请假可以撤销吗？</b></p>',
          '<p>审核完成前请假可以撤销，审核后暂时无法撤销；</p>',
          '<p><b>7、请假可以修改吗？</b></p>',
          '<p>已提交审核的请假暂时无法进行修改；</p>'
        ],
        headmaster: [],
        guardian: []
      },
      authorize: []
    }
  },
  attendanceGroup: {
    index: 'attendanceGroup',
    title: '考勤组',
    isNotInAttendance: true,
    data: {
      admin: [
        '<p>考勤组由名称、参与考勤成员、考勤时间、考勤设备组成。</p>',
        '<div><img src="/campusleave/static/img/help/help2-1.png"/></div>',
        '<p><b>刷脸考勤</b>：选中的考勤成员可在考勤设备刷脸考勤，学生考勤更舒心。</p>',
        '<div><img src="/campusleave/static/img/help/help2-2.png"/></div>',
        '<p><b>实时通知</b>：学生刷脸考勤时实时发送通知，老师家长更安心。</p>',
        '<div><img src="/campusleave/static/img/help/help2-3.png"/></div>',
        '<p><b>考勤统计</b>：定时统计学生考勤情况并发送对应的通知，学校管理更省心。</p>'
      ],
      headmaster: [],
      guardian: []
    },
    authorize: []
  },
  facedoorSet: {
    index: 'facedoorSet',
    title: '门禁权限设置',
    isNotInAttendance: true,
    data: {
      admin: [
        '<p><b>具有开门权限的学生才能完成刷脸考勤。</b>在微应用<魔点门禁-开门权限>进行设置。</p>',
        '<div><img src="/campusleave/static/img/help/help3-1.png"/></div>',
        '<p>默认关联全员组，全员组即为全校师生、家长在任何时间，任何日期内都可刷脸开门；管理员可根据学校实际需求进行修改设置。</p>',
        '<div><img src="/campusleave/static/img/help/help3-2.png"/></div>'
      ],
      headmaster: [],
      guardian: []
    },
    authorize: []
  }
}
